import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }
const _hoisted_3 = { class: "mb-1" }
const _hoisted_4 = { class: "font-medium text-catering-ink-900" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "list-disc pl-4 text-catering-ink-800" }


export default {
  __name: 'BotSmartlistDiagnosis',
  props: { block: { type: Object, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, " List check · " + _toDisplayString(__props.block.list), 1),
    _createElementVNode("p", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.block.customer), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["ml-1 rounded px-1.5 py-0.5 text-[11px] font-medium", 
          __props.block.in_list
            ? 'bg-catering-herb-100 text-catering-herb-600'
            : 'bg-catering-berry-100 text-catering-berry-600'
        ])
      }, _toDisplayString(__props.block.in_list ? 'in the list' : 'not in the list'), 3)
    ]),
    (!__props.block.in_list && (__props.block.excluded_by || []).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-[11px] font-semibold uppercase tracking-wide text-catering-honey-600" }, "Excluded by", -1)),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.excluded_by, (e, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(e.plain_english), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}